export enum ENV_LIST {
    LOCAL = 'local',
    STAGING = 'staging',
    REVIEW_APP = 'review_app',
    DEMO_01 = 'demo01',
    SANDBOX = 'sandbox',
    PRODUCTION = 'production',
}

export enum AvailableToggleFeatures {
    notifications_revamp = 'notifications_revamp',
    kits = 'kits',
    connector_shopify = 'connector_shopify',
}

const featuresByEnv = Object.freeze({
    // Usage example:
    // [ENV_LIST.LOCAL]: [AvailableToggleFeatures.ma_feature]
    [ENV_LIST.LOCAL]: [
        AvailableToggleFeatures.notifications_revamp,
        AvailableToggleFeatures.kits,
        AvailableToggleFeatures.connector_shopify,
    ],
    [ENV_LIST.STAGING]: [AvailableToggleFeatures.kits, AvailableToggleFeatures.connector_shopify],
    [ENV_LIST.REVIEW_APP]: [AvailableToggleFeatures.kits, AvailableToggleFeatures.connector_shopify],
    [ENV_LIST.DEMO_01]: [],
    [ENV_LIST.SANDBOX]: [],
    [ENV_LIST.PRODUCTION]: [],
});

export function getEnabledFeaturesByEnv(envName: ENV_LIST) {
    return featuresByEnv?.[envName];
}
